<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'90%'"
    :classDialog="'dialog-doc-out-finish edit-note-to-file'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
    :modalAppendToBody="true"
    :disableScroll="true"
  >
    <template #body>
      <el-row :gutter="12" class="">
        <el-col :span="5" class="pListThumb">
          <div class="pListThumb-Title margin-top-10">
            <h2 class="margin-botom-10 margin-top-10">Ký ban hành</h2>
          </div>
          <VuePerfectScrollbar :class="['pScroll']">
            <p-thumbnail
              v-for="(item, $itemIndex) in listImages"
              :key="`page_${$itemIndex}`"
              :url="item.url"
              :title="`Trang ${$itemIndex + 1}`"
              :active="urlDocSelected === item"
              :isModify="item.isModify"
              @click="changeSelectedDoc(item, $itemIndex)"
            ></p-thumbnail>
          </VuePerfectScrollbar>
        </el-col>
        <el-col :span="14" class="pDetailDocs">
          <detail-docs-v2
            v-if="listImages && listImages.length"
            ref="detailDoc"
            :isLoading="isChangingSelectedDoc"
          ></detail-docs-v2>
        </el-col>
        <el-col :span="5" class="pListThumb">
          <VuePerfectScrollbar :class="['pScroll scrollSignature']">
            <div class="pListThumb-Title">
              <div
                class="pListThumb-Title"
                v-if="textImages && textImages.length"
              >
                <h2 class="">
                  {{ "Thông tin văn bản" }}
                </h2>
              </div>
              <pImage
                v-for="(item, $index) in textImages"
                :key="item.id"
                :text="item.value"
                :_idCanvas="$index"
                :title="getPImageTitle(item)"
                :fontConfig="item.fontConfig"
                @addDateTimeImg="(event) => addDateTimeImg(event, item)"
              />
            </div>
            <div
              class="pListThumb-Title"
              v-if="listSignature && listSignature.length"
            >
              <h2 class="">
                {{ "Danh sách chữ ký" }}
              </h2>
            </div>

            <p-thumbnail
              v-for="(item, $itemIndex) in listSignature"
              :key="`signature_${$itemIndex}`"
              :url="item.url"
              :title="item.userDeptRoleView.fullName"
              @click="
                addImageSignature(item, DETAIL_DOCS_PAGE.SHAPE_TYPE.CHU_KY)
              "
            ></p-thumbnail>

            <div class="pListThumb-Title" v-if="listStamp && listStamp.length">
              <h2 class="margin-botom-10 margin-top-10">
                {{ "Danh sách con dấu" }}
              </h2>
            </div>

            <p-thumbnail
              v-for="(item, $index) in getPageDataSelected() ? [] : listStamp"
              :key="`stamp_${$index}`"
              :url="item.url"
              :title="item.department.deptName"
              @click="addImageStamp(item, DETAIL_DOCS_PAGE.SHAPE_TYPE.CON_DAU)"
            ></p-thumbnail>
          </VuePerfectScrollbar>
        </el-col>
      </el-row>
    </template>
    <template #footer>
      <div class="flex-row flex__left form-button__action">
        <div>
          <el-button
            class="dialogBtnSecondary"
            @click="submitTest"
            :disabled="isProcessing || isSubmitting || isChangingSelectedDoc"
          >
            <span class="flex-row flex__center">
              <i
                :class="[
                  !isProcessing && !isSubmitting
                    ? 'fas fa-save'
                    : 'el-icon-loading',
                ]"
              ></i>
              &nbsp;Xác nhận
            </span>
          </el-button>
        </div>
      </div>
      <login-sca
        :isOpen="isOpenDialogLoginSCA"
        :isSubmitting="isProcessing"
        v-if="isEnableDialogLoginSCA"
        @closed="isEnableDialogLoginSCA = false"
        @closeDialog="isOpenDialogLoginSCA = false"
        @success="afterSignFile"
      />
    </template>
  </dialogTemplate>
</template>

<script>
import constants from "../../../constants";
import buildAttachmentURL from "../../../filters/buildAttachmentURL";
import buildAttachmentImage from "../../../filters/buildAttachmentImage";
import vbAttachmentTokenService from "../../../services/vbAttachmentTokenService";
import attachmentService from "../../../services/attachmentService";
import { TYPE_LIST } from "./const-shape.js";
import vbFlowInstanceService from "../../../services/vbFlowInstanceService";
import PThumbnail from "./p-thumbnail";
import h from "../../../services/h";
import dateUtils from "../../../dateUtils";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import uuidv4 from "uuid/v4";
import DetailDocsV2 from "./detail-docs-v2";
import vbOutgoingProcessService from "../../../services/vbOutgoingProcessService";
import LoginSca from "./LoginSCA.vue";

export default {
  name: "ky-token-dialog",
  props: [
    "isOpen",
    "vbAttachmentId",
    "docId",
    "signedVbAttachmentId",
    "docDate",
    "docCode",
    "publisherDept",
    "signDate",
    "isProcessing",
    "needToSignCa"
  ],
  filters: { buildAttachmentURL, buildAttachmentImage },

  components: {
    DetailDocsV2,
    PThumbnail,
    LoginSca,
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
    dialogTemplate: () => import("../custom-dialog"),
    pThumb: () => import("./p-thumbnail"),
    pImage: () => import("./pImage.vue"),
    detailDocs: () => import("./detailDocsNew.vue"),
  },
  data() {
    return {
      type: {
        thumb: TYPE_LIST.THUMB,
        sign: TYPE_LIST.SIGNATURE,
      },

      token: null,
      listImages: [],
      urlDocSelected: null,
      listSignature: [],
      listStamp: [],
      listAttachment: [],
      flowInstanceId: null,
      trangKySo: null,
      textImages: [],
      DETAIL_DOCS_PAGE: constants.DETAIL_DOCS_PAGE,
      shapeType: null,
      vbOutgoingProcesses: null, //danh sach cac node chuyen co thuc hien ky so;
      selectedPageIndex: null,
      pagesData: [],
      isSubmitting: false,
      isChangingSelectedDoc: false,
      isOpenDialogLoginSCA: false,
      isEnableDialogLoginSCA: false,
    };
  },

  computed: {
    roleCode() {
      return this.$store.getters.userDeptRole.roleCode;
    },

    isShouldToInsertLanhDaoNotes() {
      //neu trong van ban co y kien chi dao cua lanh dao cua don vi cha don vi ban hanh >
      // thuc hien chen y kien lanh dao vao file ky so;
      return h.exists(
        this.vbOutgoingProcesses,
        (vbOutgoingProcess) =>
          vbOutgoingProcess.note &&
          vbOutgoingProcess.deptReceiverId === this.publisherDept.parentId
      );
    },
  },

  watch: {
    isOpenDialogLoginSCA(newValue) {
      newValue && (this.isEnableDialogLoginSCA = newValue);
    },
  },

  created() {
    this.loadVbFlowInstance()
      .then(() => this.generateTokenSignature())
      .then(() => this.getListSignatureImage())
      .then(() => this.generateTokenStamp())
      .then(() => this.getListStampImage())
      .then(() => this.findNotesForBanHanh())
      .then(() => this.initTextImages());
    this.initToken();
  },

  methods: {
    getPageDataSelected() {
      return (
        this.$refs.detailDoc &&
        this.$refs.detailDoc
          .getPageData()
          .shapeOptionsData.find(
            (x) =>
              x.shapeOptions.shapeType ===
              constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CON_DAU
          )
      );
    },
    // lay danh sach chi dao;
    findNotesForBanHanh() {
      return vbOutgoingProcessService
        .findNotesForBanHanh(this.docId, this.flowInstanceId)
        .then((response) => (this.vbOutgoingProcesses = response.data));
    },

    getPImageTitle(textImage) {
      switch (textImage.type) {
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PUBLISHER_INFO:
          return errorMessageFilter({
            errorCode: "signToken.publisherInfo.title",
          });
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE:
          return errorMessageFilter({ errorCode: "signToken.docCode.title" });
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PHU_LUC:
          return errorMessageFilter({ errorCode: "signToken.phuLuc.title" });
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE:
          return errorMessageFilter({ errorCode: "signToken.docDate.title" });
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.CHI_DAO:
          return errorMessageFilter({
            errorCode: "signToken.chiDao.title",
            params: [textImage.data.vbOutgoingProcess.receiverName],
          });
        default:
          return "";
      }
    },

    initTextImages() {
      let docDate_ = dateUtils.toMoment(this.docDate);
      let now_ = dateUtils.toMoment(this.signDate.getTime());

      this.textImages = [
        {
          id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE,
          type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE,
          value: errorMessageFilter({
            errorCode: "signToken.docCode",
            params: [this.docCode],
          }),
          fontConfig: {
            fontStyle: "normal",
            additionalWidth: 50,
            minLength: 200,
          },
        },
        {
          id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE,
          type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE,
          value: errorMessageFilter({
            errorCode: "signToken.docDate",
            params: [
              docDate_.get("date"),
              docDate_.get("month") + 1,
              docDate_.get("year"),
            ],
          }),
          fontConfig: { additionalWidth: 100 },
        },
        {
          id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PHU_LUC,
          type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PHU_LUC,
          value: errorMessageFilter({
            errorCode: "signToken.phuLuc",
            params: [
              this.docCode,
              docDate_.get("date"),
              docDate_.get("month") + 1,
              docDate_.get("year"),
            ],
          }),
          fontConfig: { additionalWidth: 100 },
        },
        {
          id: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PUBLISHER_INFO,
          type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PUBLISHER_INFO,
          value: errorMessageFilter({
            errorCode: "signToken.publisherInfo",
            params: [
              this.publisherDept.deptName,
              now_.format("DD/MM/YYYY HH:mm:ss"),
            ],
          }),
          fontConfig: {
            fontStyle: "normal",
            fontColor: "blue",
            additionalWidth: 0,
          },
        },
      ];

      h.each(this.vbOutgoingProcesses, (vbOutgoingProcess) => {
        this.textImages.push({
          id: uuidv4(),
          type: constants.DETAIL_DOCS_PAGE.TEXT_TYPE.CHI_DAO,
          value: errorMessageFilter({
            errorCode: "signToken.chiDao",
            params: [vbOutgoingProcess.note],
          }),
          fontConfig: {
            fontStyle: "normal",
            fontColor: "blue",
            additionalWidth: 0,
          },
          data: {
            vbOutgoingProcess: vbOutgoingProcess,
          },
        });
      });
    },

    addDateTimeImg(urlImg, textImage) {
      if (this.isProcessing || this.isSubmitting || this.isChangingSelectedDoc)
        return;
      let shapeType;
      let defaultWidth;
      let fontSize;
      let fontStyle;
      let fill;
      let addWhiteBackground = true;
      switch (textImage.type) {
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PUBLISHER_INFO:
          shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.PUBLISHER_INFO;
          defaultWidth =
            constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.PUBLISHER_INFO_WIDTH;
          fill = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.PUBLISHER_INFO_FILL;
          addWhiteBackground = false;
          break;
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_CODE:
          shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.DOC_CODE;
          defaultWidth =
            constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.DOC_CODE_WIDTH;
          break;
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.DOC_DATE:
          shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.DOC_DATE;
          defaultWidth =
            constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.DOC_DATE_WIDTH;
          fontSize =
            constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.DOC_DATE_FONT_SIZE;
          fontStyle = constants.DETAIL_DOCS_PAGE.FONTSTYLE.ITALIC;
          break;
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PHU_LUC:
          defaultWidth = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.PHU_LUC_WIDTH;
          fontSize = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.PHU_LUC_FONT_SIZE;
          shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.PHU_LUC;
          fontStyle = constants.DETAIL_DOCS_PAGE.FONTSTYLE.ITALIC;
          break;
        case constants.DETAIL_DOCS_PAGE.TEXT_TYPE.CHI_DAO:
          shapeType = constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CHI_DAO;
          defaultWidth = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.CHI_DAO_WIDTH;
          fill = constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.CHI_DAO_FILL;
          addWhiteBackground = false;
          break;
        default:
          shapeType = null;
      }
      this.$refs.detailDoc.addText({
        text: textImage.value,
        editable:
          constants.DETAIL_DOCS_PAGE.TEXT_TYPE.PHU_LUC === textImage.type,
        shapeType: shapeType,
        defaultWidth: defaultWidth,
        fontSize: fontSize,
        fontStyle: fontStyle,
        fill: fill,
        addWhiteBackground: addWhiteBackground,
      });
    },

    loadVbFlowInstance() {
      return vbFlowInstanceService
        .findCurrentOutgoingDocFlowInstance(this.docId)
        .then((response) => (this.flowInstanceId = response.data.id));
    },

    validate() {
      return new Promise((resolve) => {
        resolve(
          this.validateExistShape(
            constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.DOC_CODE,
            "signToken.error.missingDocCode"
          ) &&
            this.validateExistShape(
              constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.DOC_DATE,
              "signToken.error.missingDocDate"
            ) &&
            (!this.listSignature ||
              !this.listSignature.length ||
              this.validateExistShape(
                constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CHU_KY,
                "signToken.error.missingSignature"
              )) &&
            this.validateExistShape(
              constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.PUBLISHER_INFO,
              "signToken.error.missingPublisherInfo"
            )
        );
      });
    },

    isExistsShapeWithShapeType(shapeType) {
      return h.exists(this.pagesData, (pageData) => {
        return (
          pageData.isPageModified &&
          h.exists(
            pageData.data.shapeOptionsData,
            (shapeOptionsDataItem) =>
              shapeOptionsDataItem.shapeOptions.shapeType === shapeType
          )
        );
      });
    },

    validateExistShape(shapeType, errorCode) {
      let isExists = this.isExistsShapeWithShapeType(shapeType);
      if (!isExists) {
        if (errorCode)
          this.message(
            "Thông báo",
            errorMessageFilter({ errorCode: errorCode }),
            "error",
            2000
          );
        return false;
      }
      return true;
    },

    submitTest() {
      this.$refs.detailDoc.removeTransformer();
      return this.savePageData()
        .then(() => {
          // return this.validate()
          //   .then((isPassValidate) => {
          //     return !isPassValidate ? false : this.warningMissingStamp();
          //   })
          //   .then((isContinue) => {
          //     return !isContinue ? false : this.warningMissingLanhDaoNotes();
          //   })
          return this.warningMissingStamp().then((isContinue) => {
            if (!isContinue) return;
            if (this.needToSignCa === 1) {
              this.isSubmitting = true;
              this.isOpenDialogLoginSCA = true;
            } else {
              let modifiedPagesData = h.collect(
                h.findAll(
                  this.pagesData,
                  (pageData) => pageData.isPageModified
                ),
                (pageData) => {
                  return {
                    pageIndex: pageData.pageIndex,
                    pageImageData: pageData.pageImageData,
                  };
                }
              );
              this.$emit("submit", {
                pagesData: modifiedPagesData,
              });
            }
          });
        })
        .then((result) => {
          this.isSubmitting = false;
          return result;
        })
        .catch((error) => {
          this.isSubmitting = false;
          throw error;
        });
    },

    async afterSignFile(event) {
      let modifiedPagesData = h.collect(
        h.findAll(this.pagesData, (pageData) => pageData.isPageModified),
        (pageData) => {
          return {
            pageIndex: pageData.pageIndex,
            pageImageData: pageData.pageImageData,
          };
        }
      );
      await this.$emit("submit", { pagesData: modifiedPagesData, ...event });
    },

    waring_(options) {
      return new Promise((resolve) => {
        if (options.checkFn()) {
          this.$confirm(options.buildConfirmMessageFn(), "Cảnh báo", {
            confirmButtonText: "Tiếp tục",
            cancelButtonText: options.buildCancelButtonTextFn(),
            type: "warning",
          })
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              resolve(false);
            });
        } else {
          resolve(true);
        }
      });
    },

    async warningMissingStamp() {
      if (
        this.listStamp &&
        this.listStamp.length &&
        !this.isExistsShapeWithShapeType(
          constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CON_DAU
        )
      ) {
        this.$message({
          message: "Bạn chưa điền con dấu!",
          type: "error",
        });
        return false;
      }
      return true;
      // return this.waring_({
      //   checkFn: () => {
      //     return (
      //       this.listStamp &&
      //       this.listStamp.length &&
      //       !this.isExistsShapeWithShapeType(
      //         constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CON_DAU
      //       )
      //     );
      //   },
      //   buildConfirmMessageFn: () =>
      //     errorMessageFilter({ errorCode: "signToken.error.missingStamp" }),
      //   buildCancelButtonTextFn: () => "Thêm con dấu",
      // });
    },

    /**
     * warning trong trường hợp thiếu ý kiến của lãnh đạo
     */
    warningMissingLanhDaoNotes() {
      return this.waring_({
        checkFn: () => {
          return (
            this.isShouldToInsertLanhDaoNotes &&
            !this.isExistsShapeWithShapeType(
              constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CHI_DAO
            )
          );
        },
        buildConfirmMessageFn: () =>
          errorMessageFilter({
            errorCode: "signToken.error.warningForLanhDaoNotes",
          }),
        buildCancelButtonTextFn: () => "Thêm ý kiến LĐ",
      });
    },

    generateTokenStamp() {
      return attachmentService
        .getStampInfo(this.flowInstanceId)
        .then((res) => (this.listAttachmentStamp = res.data));
    },

    getListStampImage() {
      this.listStamp = [];
      return Promise.all(
        h.collect(this.listAttachmentStamp, (stampInfoForm) => {
          let department = stampInfoForm.department;
          let vbAttachment = stampInfoForm.vbAttachment;
          return vbAttachmentTokenService
            .getToken(vbAttachment.id)
            .then((res) => {
              this.listStamp.push({
                url: buildAttachmentURL(res.data.token, {
                  type: constants.DOWNLOAD_OPTION.TYPE.STAMP,
                }),
                department: department,
              });
            });
        })
      );
    },

    generateTokenSignature() {
      return attachmentService
        .getListUserSigned(this.flowInstanceId)
        .then((res) => (this.listAttachment = res.data));
    },

    getListSignatureImage() {
      this.listSignature = [];
      h.each(this.listAttachment, (item) => {
        let signature = { userDeptRoleView: item.userDeptRoleView };
        vbAttachmentTokenService.getToken(item.vbAttachment.id).then((res) =>
          this.$set(
            signature,
            "url",
            buildAttachmentURL(res.data.token, {
              type: constants.DOWNLOAD_OPTION.TYPE.SIGNATURE,
            })
          )
        );
        this.listSignature.push(signature);
      });
    },

    initToken() {
      this.getTokenOriginal()
        .then(() => this.getPageSize())
        .then(() => this.downloadImageOriginal());
    },

    getPageSize() {
      return attachmentService
        .getPageSize(this.vbAttachmentId)
        .then((response) => (this.pageSize = response.data.pageSize))
        .catch(() => (this.pageSize = 0));
    },

    changeImg(obj) {
      let index = this.listImages.findIndex((item) => item.url === obj.url);
      this.$set(this.listImages[index], "uri", obj.uri);
      this.$set(this.listImages[index], "isModify", true);
    },

    getTokenOriginal() {
      return vbAttachmentTokenService
        .getToken(this.vbAttachmentId, this.docId)
        .then((response) => (this.token = response.data.token));
    },

    downloadImageOriginal() {
      this.listImages = [];
      for (let i = 0; i < this.pageSize; i++) {
        this.listImages.push({
          id: i,
          url: buildAttachmentImage(this.token, {
            type: constants.DOWNLOAD_OPTION.TYPE.IMAGE,
            imageStatus: "original",
            pageNumber: i,
          }),
        });
      }
      this.$nextTick(() => {
        this.changeSelectedDoc(this.listImages[0], 0);
      });
    },

    changeSelectedDoc(page, pageIndex) {
      if (this.isProcessing || this.isSubmitting || this.isChangingSelectedDoc)
        return;
      this.$refs.detailDoc.removeTransformer();
      this.isChangingSelectedDoc = true;
      return (
        this.selectedPageIndex !== pageIndex
          ? this.savePageData()
          : Promise.resolve(null)
      )
        .then(() => {
          this.urlDocSelected = page;
          this.selectedPageIndex = pageIndex;
          let pageData = this.getPageData(pageIndex);
          return this.$refs.detailDoc.loadPage({
            backgroundURL: this.urlDocSelected.url,
            pageData: pageData ? pageData.data : null,
          });
        })
        .then((result) => {
          this.isChangingSelectedDoc = false;
          return result;
        });
    },

    savePageData() {
      if (this.selectedPageIndex == null) return Promise.resolve(null);
      let isPageModified = this.$refs.detailDoc.isPageModified();
      return (
        isPageModified
          ? this.$refs.detailDoc.getPageImageData()
          : Promise.resolve(null)
      ).then((pageImageData) => {
        let pageData = this.getPageData(this.selectedPageIndex);
        if (!pageData)
          this.pagesData.push(
            (pageData = { pageIndex: this.selectedPageIndex })
          );
        pageData.data = isPageModified
          ? this.$refs.detailDoc.getPageData()
          : null;
        pageData.pageImageData = pageImageData;
        pageData.isPageModified = isPageModified;
      });
    },

    getPageData(pageIndex) {
      return h.find(
        this.pagesData,
        (pageData) => pageData.pageIndex === pageIndex
      );
    },

    addImageSignature(item, shapeType) {
      if (this.isProcessing || this.isSubmitting || this.isChangingSelectedDoc)
        return;
      this.$refs.detailDoc.addImage({
        url: item.url,
        shapeType: shapeType,
        defaultWidth: 250,
      });
    },

    addImageStamp(item, shapeType) {
      if (this.isProcessing || this.isSubmitting || this.isChangingSelectedDoc)
        return;
      this.$refs.detailDoc.addImage({
        url: item.url,
        fixedWidth: constants.DETAIL_DOCS_PAGE.STYLE_DEFAULT.STAMP_FIXED_WIDHT,
        shapeType: shapeType,
      });
    },
  },
};
</script>

<style lang="css">
.pListThumb {
  max-height: calc(100vh - 100px);
  height: auto;
}

.scrollSignature .pListThumb-Title {
  color: var(--color-blue);
}

.pListThumb-Title {
  margin-bottom: 12px;
}

.pScroll {
  max-height: calc(100vh - 160px);
  height: auto;
  margin-top: 22px;
  /* margin-bottom: 10px; */
}

.pScroll.scrollSignature {
  margin-top: 58px;
  max-height: calc(100vh - 163px);
}

.pScroll.scrollWatchingNote {
  max-height: calc(100vh - 206px);
}

.pThumb {
  max-width: calc(100% - 10px);
  height: 100%;
  max-height: 350px;
  margin-bottom: 10px;
  border-radius: 8px;
  border: 1px solid #ceced2;
  position: relative;
  transition: all 0.25s ease-in-out;
}

.pThumb.active {
  border: 2px solid #007aff;
  transition: all 0.25s ease-in-out;
}

.pThumb .markIsModified.off {
  visibility: hidden;
}

.pThumb .markIsModified.on {
  visibility: visible;
}

.pThumb .markIsModified {
  position: absolute;
  width: 12px;
  height: 12px;
  flex: 0 0 auto;
  background-color: #e54d42;
  top: 3px;
  right: 3px;
  border-radius: 50%;
}

.pThumb .pBgThumb {
  max-width: 90%;
  width: 100%;
  height: 150px;
  margin: 0 10px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.pThumb .pIndex {
  position: absolute;
  width: 100%;
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgb(255, 255, 255)
  );
  height: 60px;
  bottom: 0;
  z-index: 0;
  border-radius: 0 0 8px 8px;
  padding: 0 10px;
  padding-bottom: 10px;
  align-items: flex-end;
  justify-content: center;
  color: #2d3e4f;
}

.pDetailDocs {
  max-height: calc(100vh - 100px);
  height: auto;
}

.pControl {
  padding: 10px 0;
  height: 56px;
}

.pDetail {
  max-height: calc(100vh - 100px);
  height: auto;
}

.pScrollDoc {
  max-height: calc(100vh - 165px);
  height: auto;
  border: 1px solid #abb4bd;
  border-bottom-color: transparent;
  border-radius: 8px 0 0 0;
}

.pScrollDoc.pWatchingNote {
  margin-top: 56px;
}

.page-center > div {
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: calc(100vh - 140px);
  height: calc(100vh - 140px);
  position: relative;
}

.BtnEdit {
  background-color: #efeff4;
  border: 1px solid red;
  font-size: 18px;
}

.BtnEdit.el-button.is-disabled {
  border: 1px solid red;
}

.edit-note-to-file.dialog-doc-out-finish {
  /* height: calc(100% - 30px) !important; */
}
</style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/ky-token-dialog.vue